import React from 'react'

function IngredientRow(props) {
    return (
        <div className="IngredientRow">
            <span className='ingredientRowQty'>{props.qty }</span> 
            <span className='ingredientRowName'>{props.name }</span>
        </div>
    )
}

export default function RecipeDetails(props) {
    const recipePicture = 
    "https://s23209.pcdn.co/wp-content/uploads/2019/01/Instant-Pot-Rotisserie-ChickenIMG_8266.jpg"

    const dummyingredients = [
        {   
            qty: "1 whole (4 to 5 pounds)",
            name: " Chicken",
            
        },
        {
            qty: "2 teaspoons ",
            name: "Paprika",
        },
        {
            qty: "1 1/2 teaspoons",
            name: " dried thyme",
        },
        {
            qty: "1 teaspoon",
            name: " garlic powder",
        },
        {
            qty: "1 teaspoon",
            name: " onion powder",
        },
        {
            qty: "2 tablespoons",
            name: " virgin olive oil"
        },

        
    ]

    return (
        <div className = 'RecipeDetails'>
            <div className = 'container'> 
                <img src={recipePicture} alt="Not available"/>
                <div className = 'recipeTitleClass'> Rotisserie Chicken</div>
            </div>
            <div className = 'secondContainer'>
                <div className = 'ingredientTitleClass'> 7 Ingredients</div>
                <div className = 'caloriesTitleClass'>347 Calories</div>
                <div className = 'timeTitleClass'>1 hour 15 minutes</div>
                <div className = 'ingredientListClass'>Ingredients</div>
                <div className = 'addAllClass'>
                    <div className = 'addAllShoppingTextClass'><i className = 'material-icons'>add</i>Add to shopping cart</div>
                </div>
                <div className = 'shareMediaClass'> 
                    <div className = 'shareMediaTextClass'><i className = 'material-icons'>share</i>Share</div>
                </div>
            </div>
            


            { dummyingredients.map(ingredient => <IngredientRow  qty={ingredient.qty} name={ingredient.name}/>) }
        </div>
        /*(<div className='RecipeDetails'>
            <img src={recipePicture} alt="Not available"/>
            <div className="titlebar">
                <span className='ingredientTitleClass'>Ingredient</span>
                <span className='caloriesTitleClass'>Calories</span>
                <span className='timeTitleClass'>Time</span>
                
            </div>
            { dummyingredients.map(ingredient => <IngredientRow name={ingredient.name} qty={ingredient.qty}/>) }
        </div> */
    )
}

